var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    d: "M12.5.5c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12m3.404 4.8h-2.626c-1.542 0-2.792 1.161-2.792 2.594v2.055h-1.39c-.108 0-.196.081-.196.181v2.132c0 .1.088.181.195.181h1.391v7.076c0 .1.088.181.195.181h2.783c.108 0 .195-.081.195-.181v-7.076h2.018c.1 0 .186-.072.194-.166l.194-2.132c.01-.105-.08-.196-.195-.196h-2.21V8.436c0-.354.309-.641.69-.641h1.554c.108 0 .196-.082.196-.182V5.481c0-.1-.088-.181-.196-.181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h24v24H.5z"
  })))));
};
export default SvgFacebook;